import React from "react";
import "@google/model-viewer";

export default function ARModelViewer({ glbUrl, usdzUrl, modelViewerRef, hidden }) {
  return (
    <>
      {/* Google'ın model-viewer bileşeni */}
      <script
        type="module"
        src="https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js"
      ></script>

      <model-viewer
        ref={modelViewerRef}
        src={glbUrl}
        ios-src={usdzUrl}
        alt="Cam Balkon Modeli"
        ar
        ar-modes="scene-viewer quick-look"
        auto-rotate
        camera-controls
        environment-image="neutral"
        exposure="1"
        style={{
          display: hidden ? "none" : "block",
          width: "100%",
          height: "500px"
        }}
      ></model-viewer>
    </>
  );
}